export default "__VITE_PUBLIC_ASSET__607a4474__"